function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./progress.scss";
import template from "./progress.html";

export var ProgressComponent = {
  template: template,
  bindings: {
    fats: "<",
    carbs: "<",
    pro: "<",
    viewTitle: "@",
    calories: "<",
    isWater: "<",
    waterData: '<' },

  controller: /*#__PURE__*/function () {ProgressComponentController.$inject = ["LayoutService", "$rootScope"];
    function ProgressComponentController(LayoutService, $rootScope) {
      "ngInject";_classCallCheck(this, ProgressComponentController);
      this.LayoutService = LayoutService;
      this.$rootScope = $rootScope;
      this.isWater = false;
      this.waterProgress = 0;
      console.log(this);
    }_createClass(ProgressComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this = this;
        this.$rootScope.$on('onReadyMeals', function (e, meals) {return _this.meals = meals;});
      } }, { key: "$onChanges", value: function $onChanges()

      {
        if (this.waterData && this.waterData.hasOwnProperty('currentDay')) {
          this.waterProgress = Math.ceil(this.waterData.currentDay / this.waterData.goal * 100);
        }
      } }]);return ProgressComponentController;}() };